// helper function that takes in words and either adds an 's' to the end depending on the value of count. If count is not 1, then an 's' is added, if not, then nothing is added.
export const pluralizeWord = (word: string, count: number) => {
  return word + (count !== 1 ? 's' : '');
};
